import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Form from '../../components/Form/Form';
import MasterCreationFooter from '../../components/Footer/Master_Footer/MasterCreationFooter';
import { toast } from 'react-toastify';
import { getVoucherDate } from '../../components/Date_Formate_Utilitiy/Index';
import DropdownLayout_1 from '../../components/Dropdown/DropdownLayout_1';

function BranchCreateModal({ closeModal_sec, onSuccess, editData, viewOnly }) {
    const [submitConfirm, setSubmitConfirm] = useState('');
    const [loading, setLoading] = useState(false);

    // Initial state for form fields matching screenshot
    const [formData, setFormData] = useState({
        branchName: editData ? editData.name : 'Pachore Road',
        branchCode: editData ? editData.branch_code : 'Auto Generated',
        branchManager: editData ? editData.branch_manager : 'Kamal Kushwah (Ac No)',
        under: editData ? editData.under : 'Main Location',
        branchStatus: editData ? editData.status : 'Active',
        allowedBackDated: editData ? (editData.allowedBackDated || 'Yes') : 'Yes',
        cutOffDate: editData ? (editData.cutOffDate || '23-Dec-2025 (Tuesday)') : '23-Dec-2025 (Tuesday)',
        mailingName: editData ? (editData.mailingName || '') : 'Yadav Krishi Sewa Kendra',
        mailingAddress1: editData ? (editData.mailingAddress1 || '') : 'Pachore Road, Near Police Station',
        mailingAddress2: editData ? (editData.mailingAddress2 || '') : 'Boda',
        mailingState: editData ? (editData.mailingState || '') : 'Madhya Pradesh',
        mailingPincode: editData ? (editData.mailingPincode || '') : '465685',
        mailingMobile: editData ? (editData.mailingMobile || '') : '91 9617965916',
        mailingEmail: editData ? (editData.mailingEmail || '') : 'snlyadav11@gmail.com'
    });

    const [showBranchManagerDropdown, setShowBranchManagerDropdown] = useState(false);
    const [showUnderDropdown, setShowUnderDropdown] = useState(false);
    const [showBranchStatusDropdown, setShowBranchStatusDropdown] = useState(false);
    const [showAllowedBackDatedDropdown, setShowAllowedBackDatedDropdown] = useState(false);
    const [cutOffDateRaw, setCutOffDateRaw] = useState(
        editData ? ((editData.cutOffDate || '23-Dec-2025 (Tuesday)').replace(/\s*\(.*\)/, '').trim()) : '23-Dec-2025'
    );

    const { company_session } = useSelector(state => state.common);

    // Focus references
    const refs = {
        branchName: useRef(null),
        branchManager: useRef(null),
        under: useRef(null),
        branchStatus: useRef(null),
        allowedBackDated: useRef(null),
        cutOffDate: useRef(null),
        mailingName: useRef(null),
        mailingAddress1: useRef(null),
        mailingAddress2: useRef(null),
        mailingState: useRef(null),
        mailingPincode: useRef(null),
        mailingMobile: useRef(null),
        mailingEmail: useRef(null)
    };

    // Sequential inputs order for Enter key navigation
    const inputOrder = [
        'branchName', 'branchManager', 'under', 'branchStatus', 'allowedBackDated', 'cutOffDate',
        'mailingName', 'mailingAddress1', 'mailingAddress2', 'mailingState', 'mailingPincode', 'mailingMobile', 'mailingEmail'
    ];

    useEffect(() => {
        // Block global Escape navigation while this modal is open
        document.body.setAttribute('data-modal-open', 'true');
        // Auto focus the first field on mount
        setTimeout(() => {
            refs.branchName.current?.focus();
            refs.branchName.current?.select();
        }, 100);
        return () => {
            document.body.removeAttribute('data-modal-open');
        };
    }, []);

    // Global Escape key listener
    useEffect(() => {
        const handleEscapeKey = (e) => {
            if (e.key === 'Escape') {
                if (viewOnly) {
                    e.preventDefault();
                    closeModal_sec && closeModal_sec();
                    return;
                }
                e.preventDefault();
                setSubmitConfirm(prev => {
                    if (prev === 'Accept' || prev === 'Quit') return prev;
                    return 'Quit';
                });
            }
        };
        document.addEventListener('keydown', handleEscapeKey, true);
        return () => document.removeEventListener('keydown', handleEscapeKey, true);
    }, [viewOnly, closeModal_sec]);

    const validateField = (name) => {
        if (viewOnly) return true;
        const value = (formData[name] || '').trim();
        if (name === 'branchName') {
            if (!value) {
                toast.error("Branch Name is required", { position: toast.POSITION.TOP_CENTER });
                refs.branchName.current?.focus();
                return false;
            }
        }
        if (name === 'branchManager') {
            if (!value) {
                toast.error("Branch Manager is required", { position: toast.POSITION.TOP_CENTER });
                refs.branchManager.current?.focus();
                return false;
            }
        }
        if (name === 'under') {
            if (!value) {
                toast.error("Under is required", { position: toast.POSITION.TOP_CENTER });
                refs.under.current?.focus();
                return false;
            }
        }
        if (name === 'branchStatus') {
            if (!value) {
                toast.error("Branch Status is required", { position: toast.POSITION.TOP_CENTER });
                refs.branchStatus.current?.focus();
                return false;
            }
        }
        if (name === 'allowedBackDated') {
            if (!value) {
                toast.error("Allowed for Back Dated Vouchers is required", { position: toast.POSITION.TOP_CENTER });
                refs.allowedBackDated.current?.focus();
                return false;
            }
        }
        if (name === 'cutOffDate') {
            if (formData.allowedBackDated === 'No') return true;
            if (!value) {
                toast.error("Cut-Off Date is required", { position: toast.POSITION.TOP_CENTER });
                refs.cutOffDate.current?.focus();
                return false;
            }
        }
        if (name === 'mailingName') {
            if (!value) {
                toast.error("Mailing Name is required", { position: toast.POSITION.TOP_CENTER });
                refs.mailingName.current?.focus();
                return false;
            }
        }
        if (name === 'mailingAddress1') {
            if (!value) {
                toast.error("Address Line 1 is required", { position: toast.POSITION.TOP_CENTER });
                refs.mailingAddress1.current?.focus();
                return false;
            }
        }
        if (name === 'mailingAddress2') {
            if (!value) {
                toast.error("Address Line 2 is required", { position: toast.POSITION.TOP_CENTER });
                refs.mailingAddress2.current?.focus();
                return false;
            }
        }
        if (name === 'mailingState') {
            if (!value) {
                toast.error("State is required", { position: toast.POSITION.TOP_CENTER });
                refs.mailingState.current?.focus();
                return false;
            }
        }
        if (name === 'mailingPincode') {
            if (!value) {
                toast.error("Pincode is required", { position: toast.POSITION.TOP_CENTER });
                refs.mailingPincode.current?.focus();
                return false;
            }
            if (!/^\d{6}$/.test(value)) {
                toast.error("Invalid pincode (should be exactly 6 digits)", { position: toast.POSITION.TOP_CENTER });
                refs.mailingPincode.current?.focus();
                return false;
            }
        }
        if (name === 'mailingMobile') {
            if (!value) {
                toast.error("Primary Mobile No. is required", { position: toast.POSITION.TOP_CENTER });
                refs.mailingMobile.current?.focus();
                return false;
            }
        }
        if (name === 'mailingEmail') {
            if (!value) {
                toast.error("Email is required", { position: toast.POSITION.TOP_CENTER });
                refs.mailingEmail.current?.focus();
                return false;
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                toast.error("Invalid email format (e.g. name@domain.com)", { position: toast.POSITION.TOP_CENTER });
                refs.mailingEmail.current?.focus();
                return false;
            }
        }
        return true;
    };

    const applyCutOffDate = (rawValue) => {
        if (!rawValue) return false;
        const dateResult = getVoucherDate(rawValue, company_session, formData.cutOffDate);
        if (dateResult && dateResult.formattedDateString) {
            const fullDate = `${dateResult.formattedDateString} (${dateResult.day_show})`;
            setFormData(prev => ({ ...prev, cutOffDate: fullDate }));
            setCutOffDateRaw(dateResult.formattedDateString);
            return true;
        }
        return false;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const updated = { ...prev, [name]: value };
            if (name === 'allowedBackDated' && value.toLowerCase() === 'no') {
                updated.cutOffDate = '';
                setCutOffDateRaw('');
            }
            return updated;
        });
    };

    const handleFormKeyDown = (e) => {
        if (e.key === 'Tab' && e.shiftKey) {
            // Shift + Tab: navigate backward without validation
            e.preventDefault();
            const currentIndex = inputOrder.indexOf(e.target.name);
            if (currentIndex > 0) {
                let prevFieldName = inputOrder[currentIndex - 1];
                if (prevFieldName === 'cutOffDate' && formData.allowedBackDated === 'No') {
                    prevFieldName = 'allowedBackDated';
                }
                refs[prevFieldName].current?.focus();
            }
            return;
        }

        if ((e.key === 'Enter' || e.key === 'Tab') && e.target.tagName !== 'TEXTAREA') {
            // If any dropdown is open, let DropdownLayout_1 handle Enter/Tab
            if (showBranchManagerDropdown && e.target.name === 'branchManager') return;
            if (showUnderDropdown && e.target.name === 'under') return;
            if (showBranchStatusDropdown && e.target.name === 'branchStatus') return;
            if (showAllowedBackDatedDropdown && e.target.name === 'allowedBackDated') return;

            // Validate current field before allowing to move forward
            if (!validateField(e.target.name)) {
                e.preventDefault();
                return;
            }

            e.preventDefault();
            const currentIndex = inputOrder.indexOf(e.target.name);
            if (currentIndex !== -1) {
                if (e.target.name === 'allowedBackDated' && formData.allowedBackDated === 'No') {
                    refs.mailingName.current?.focus();
                    return;
                }
                if (currentIndex < inputOrder.length - 1) {
                    const nextFieldName = inputOrder[currentIndex + 1];
                    if (nextFieldName === 'cutOffDate' && formData.allowedBackDated === 'No') {
                        refs.mailingName.current?.focus();
                        return;
                    }
                    refs[nextFieldName].current?.focus();
                } else if (currentIndex === inputOrder.length - 1) {
                    if (viewOnly) {
                        closeModal_sec && closeModal_sec();
                    } else {
                        setSubmitConfirm('Accept');
                    }
                }
            }
        } else if (e.key === 'Escape') {
            e.preventDefault();
            if (viewOnly) {
                closeModal_sec && closeModal_sec();
            } else {
                setSubmitConfirm('Quit');
            }
        }
    };

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        if (viewOnly) return;
        // Quit confirmation
        if (e && e.type === 'quit') {
            setSubmitConfirm('');
            closeModal_sec && closeModal_sec();
            return;
        }
        // Accept confirmation
        if (!submitConfirm) {
            let hasErrors = false;
            for (const field of inputOrder) {
                if (field === 'cutOffDate' && formData.allowedBackDated === 'No') {
                    continue;
                }
                if (!validateField(field)) {
                    hasErrors = true;
                    break;
                }
            }
            if (hasErrors) return;
            setSubmitConfirm('Accept');
            return;
        }
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            toast.success(editData ? "Branch altered successfully!" : "Branch created successfully!", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 1500
            });
            if (onSuccess) {
                let code = editData ? editData.branch_code : '99';
                if (!editData) {
                    if (formData.branchName.toLowerCase().includes('road')) code = '11';
                    else if (formData.branchName.toLowerCase().includes('pachore')) code = '74';
                    else code = String(Math.floor(Math.random() * 90) + 10);
                }

                onSuccess({
                    name: formData.branchName,
                    branch_code: code,
                    address: formData.mailingAddress2 || 'N/A',
                    under: formData.under,
                    branch_manager: formData.branchManager,
                    mobile: formData.mailingMobile.replace('91 ', ''),
                    status: formData.branchStatus,
                    allowedBackDated: formData.allowedBackDated,
                    cutOffDate: formData.allowedBackDated === 'No' ? '' : formData.cutOffDate,
                    mailingName: formData.mailingName,
                    mailingAddress1: formData.mailingAddress1,
                    mailingAddress2: formData.mailingAddress2,
                    mailingState: formData.mailingState,
                    mailingPincode: formData.mailingPincode,
                    mailingMobile: formData.mailingMobile,
                    mailingEmail: formData.mailingEmail
                });
            }
            closeModal_sec && closeModal_sec();
        }, 800);
    };

    const handleFocusReset = () => {
        setSubmitConfirm('');
        refs.branchName.current?.focus();
    };

    // Bottom Grid Data from screenshot
    const gridData = [
        { godown: 'Main Location', voucher: 'Contra', user: 'Kamal Kushwah (kamal456) Parsukhedi' },
        { godown: 'Pachore Road - Boda', voucher: 'Credit Note', user: 'Sunil Yadav (snlyadav11) Boda' },
        { godown: 'Pachore', voucher: 'Debit Note', user: '' },
        { godown: '', voucher: 'Delivery Note', user: '' },
        { godown: '', voucher: 'Journal', user: '' },
        { godown: '', voucher: 'Payment', user: '' },
        { godown: '', voucher: 'Physical Stock', user: '' },
        { godown: '', voucher: 'Purchase', user: '' },
        { godown: '', voucher: 'Purchase Order', user: '' },
        { godown: '', voucher: 'Receipt', user: '' },
        { godown: '', voucher: 'Receipt Note', user: '' },
        { godown: '', voucher: 'Sales', user: '' },
        { godown: '', voucher: 'Sales Order', user: '' },
        { godown: '', voucher: 'Stock Transfer', user: '' },
    ];

    const managers = ['Kamal Kushwah (Ac No)', 'Amar Dubey (Ac No)', 'Sunil Yadav (Ac No)', 'Deepak Rathore (Ac No)'];
    const unders = ['Main Location', 'Primary'];
    const statuses = ['Active', 'Inactive'];
    const yesNoOptions = ['Yes', 'No'];

    return (
        <Form
            handleSubmit={handleSubmit}
            handleKeyDown={handleFormKeyDown}
            submitConfirm={submitConfirm}
            handleFocusReset={handleFocusReset}
            title={viewOnly ? 'Branch View' : editData ? 'Branch Alteration' : 'Branch Creation'}
            loading={loading}
            col='col-12'
            Footer={MasterCreationFooter}
            closeModal_sec={closeModal_sec}
            isView={viewOnly}
            isAlter={!!editData && !viewOnly}
        >
            <div className="container-fluid p-2" style={{ background: '#f8f9fa', fontSize: '11px', display: 'flex', flexDirection: 'column', maxHeight: '82vh' }}>
                
                {/* Main Two-Column Layout */}
                <div className="row g-2 mb-2 bg-white p-3 border rounded shadow-sm m-0">
                    
                    {/* Left Column - Branch Settings */}
                    <div className="col-md-6 border-end pe-3">
                        <div className="row align-items-center mb-1">
                            <div className="col-5 fw-bold text-start">Branch Name</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-6">
                                <input
                                    type="text"
                                    name="branchName"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.branchName}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.branchName}
                                    style={{ fontSize: '11px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-5 fw-bold text-start">Branch Code</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-6 text-start text-muted fw-bold ps-3">
                                {formData.branchCode}
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-5 fw-bold text-start">Branch Manager (Ac No.)</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-6" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    name="branchManager"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.branchManager}
                                    ref={refs.branchManager}
                                    style={{ fontSize: '11px', background: viewOnly ? '' : '#eef2f7' }}
                                    disabled={viewOnly}
                                    autoComplete="off"
                                    placeholder="Search Manager..."
                                    onChange={e => {
                                        const val = e.target.value;
                                        setFormData(prev => ({ ...prev, branchManager: val }));
                                        setShowBranchManagerDropdown(true);
                                    }}
                                    onFocus={e => {
                                        e.target.select();
                                        if (!viewOnly) setShowBranchManagerDropdown(true);
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setShowBranchManagerDropdown(false);
                                            setFormData(prev => {
                                                const match = managers.find(m => m.toLowerCase() === prev.branchManager.toLowerCase());
                                                if (match) return { ...prev, branchManager: match };
                                                const prevVal = editData ? editData.branch_manager : managers[0];
                                                const oldMatch = managers.find(m => m.toLowerCase() === prevVal.toLowerCase());
                                                return { ...prev, branchManager: oldMatch || managers[0] };
                                            });
                                        }, 200);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Escape') setShowBranchManagerDropdown(false);
                                    }}
                                />
                                {!viewOnly && (
                                    <DropdownLayout_1
                                        ref={refs.branchManager}
                                        title="List of Branch Managers"
                                        state={showBranchManagerDropdown}
                                        input_value={formData.branchManager}
                                        input_key="branchManager"
                                        rawData={managers.map(m => ({ name: m }))}
                                        data={formData}
                                        setData={() => {}}
                                        handleDropdownClick={(key, value) => {
                                            setFormData(prev => ({ ...prev, branchManager: value }));
                                            setShowBranchManagerDropdown(false);
                                            setTimeout(() => refs.under.current?.focus(), 50);
                                        }}
                                        inputRefs={refs}
                                        bypassFilter={managers.includes(formData.branchManager)}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-5 fw-bold text-start">Under</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-6" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    name="under"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.under}
                                    ref={refs.under}
                                    style={{ fontSize: '11px', background: viewOnly ? '' : '#eef2f7' }}
                                    disabled={viewOnly}
                                    autoComplete="off"
                                    placeholder="Search Under..."
                                    onChange={e => {
                                        const val = e.target.value;
                                        setFormData(prev => ({ ...prev, under: val }));
                                        setShowUnderDropdown(true);
                                    }}
                                    onFocus={e => {
                                        e.target.select();
                                        if (!viewOnly) setShowUnderDropdown(true);
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setShowUnderDropdown(false);
                                            setFormData(prev => {
                                                const match = unders.find(u => u.toLowerCase() === prev.under.toLowerCase());
                                                if (match) return { ...prev, under: match };
                                                const prevVal = editData ? editData.under : unders[0];
                                                const oldMatch = unders.find(u => u.toLowerCase() === prevVal.toLowerCase());
                                                return { ...prev, under: oldMatch || unders[0] };
                                            });
                                        }, 200);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Escape') setShowUnderDropdown(false);
                                    }}
                                />
                                {!viewOnly && (
                                    <DropdownLayout_1
                                        ref={refs.under}
                                        title="List of Locations"
                                        state={showUnderDropdown}
                                        input_value={formData.under}
                                        input_key="under"
                                        rawData={unders.map(u => ({ name: u }))}
                                        data={formData}
                                        setData={() => {}}
                                        handleDropdownClick={(key, value) => {
                                            setFormData(prev => ({ ...prev, under: value }));
                                            setShowUnderDropdown(false);
                                            setTimeout(() => refs.branchStatus.current?.focus(), 50);
                                        }}
                                        inputRefs={refs}
                                        bypassFilter={unders.includes(formData.under)}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row align-items-center mb-1 mt-3">
                            <div className="col-5 fw-bold text-start">Branch Status</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-6" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    name="branchStatus"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.branchStatus}
                                    ref={refs.branchStatus}
                                    style={{ fontSize: '11px', background: viewOnly ? '' : '#eef2f7' }}
                                    disabled={viewOnly}
                                    autoComplete="off"
                                    placeholder="Search Status..."
                                    onChange={e => {
                                        const val = e.target.value;
                                        setFormData(prev => ({ ...prev, branchStatus: val }));
                                        setShowBranchStatusDropdown(true);
                                    }}
                                    onFocus={e => {
                                        e.target.select();
                                        if (!viewOnly) setShowBranchStatusDropdown(true);
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setShowBranchStatusDropdown(false);
                                            setFormData(prev => {
                                                const match = statuses.find(s => s.toLowerCase() === prev.branchStatus.toLowerCase());
                                                if (match) return { ...prev, branchStatus: match };
                                                const prevVal = editData ? editData.status : statuses[0];
                                                const oldMatch = statuses.find(s => s.toLowerCase() === prevVal.toLowerCase());
                                                return { ...prev, branchStatus: oldMatch || statuses[0] };
                                            });
                                        }, 200);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Escape') setShowBranchStatusDropdown(false);
                                    }}
                                />
                                {!viewOnly && (
                                    <DropdownLayout_1
                                        ref={refs.branchStatus}
                                        title="List of Statuses"
                                        state={showBranchStatusDropdown}
                                        input_value={formData.branchStatus}
                                        input_key="branchStatus"
                                        rawData={statuses.map(s => ({ name: s }))}
                                        data={formData}
                                        setData={() => {}}
                                        handleDropdownClick={(key, value) => {
                                            setFormData(prev => ({ ...prev, branchStatus: value }));
                                            setShowBranchStatusDropdown(false);
                                            setTimeout(() => refs.allowedBackDated.current?.focus(), 50);
                                        }}
                                        inputRefs={refs}
                                        bypassFilter={statuses.includes(formData.branchStatus)}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-5 fw-bold text-start">Allowed for Back Dated Vouchers</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-6" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    name="allowedBackDated"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.allowedBackDated}
                                    ref={refs.allowedBackDated}
                                    style={{ fontSize: '11px', background: viewOnly ? '' : '#eef2f7' }}
                                    disabled={viewOnly}
                                    autoComplete="off"
                                    placeholder="Search Allowed..."
                                    onChange={e => {
                                        const val = e.target.value;
                                        setFormData(prev => {
                                            const updated = { ...prev, allowedBackDated: val };
                                            if (val.toLowerCase() === 'no') {
                                                updated.cutOffDate = '';
                                                setCutOffDateRaw('');
                                            }
                                            return updated;
                                        });
                                        setShowAllowedBackDatedDropdown(true);
                                    }}
                                    onFocus={e => {
                                        e.target.select();
                                        if (!viewOnly) setShowAllowedBackDatedDropdown(true);
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setShowAllowedBackDatedDropdown(false);
                                            setFormData(prev => {
                                                const match = yesNoOptions.find(o => o.toLowerCase() === prev.allowedBackDated.toLowerCase());
                                                if (match) {
                                                    if (match === 'No') {
                                                        setCutOffDateRaw('');
                                                        return { ...prev, allowedBackDated: match, cutOffDate: '' };
                                                    }
                                                    return { ...prev, allowedBackDated: match };
                                                }
                                                const prevVal = editData ? editData.allowedBackDated : yesNoOptions[0];
                                                const oldMatch = yesNoOptions.find(o => o.toLowerCase() === prevVal.toLowerCase());
                                                if (oldMatch === 'No') {
                                                    setCutOffDateRaw('');
                                                    return { ...prev, allowedBackDated: oldMatch || yesNoOptions[0], cutOffDate: '' };
                                                }
                                                return { ...prev, allowedBackDated: oldMatch || yesNoOptions[0] };
                                            });
                                        }, 200);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Escape') setShowAllowedBackDatedDropdown(false);
                                    }}
                                />
                                {!viewOnly && (
                                    <DropdownLayout_1
                                        ref={refs.allowedBackDated}
                                        title="List of Options"
                                        state={showAllowedBackDatedDropdown}
                                        input_value={formData.allowedBackDated}
                                        input_key="allowedBackDated"
                                        rawData={yesNoOptions.map(o => ({ name: o }))}
                                        data={formData}
                                        setData={() => {}}
                                        handleDropdownClick={(key, value) => {
                                            setFormData(prev => {
                                                const updated = { ...prev, allowedBackDated: value };
                                                if (value === 'No') {
                                                    updated.cutOffDate = '';
                                                    setCutOffDateRaw('');
                                                }
                                                return updated;
                                            });
                                            setShowAllowedBackDatedDropdown(false);
                                            if (value === 'No') {
                                                setTimeout(() => refs.mailingName.current?.focus(), 50);
                                            } else {
                                                setTimeout(() => refs.cutOffDate.current?.focus(), 50);
                                            }
                                        }}
                                        inputRefs={refs}
                                        bypassFilter={yesNoOptions.includes(formData.allowedBackDated)}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-5 fw-bold text-start">Cut-Off Date for Back Dated Vouchers</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-6">
                                <input
                                    type="text"
                                    name="cutOffDate"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={cutOffDateRaw}
                                    ref={refs.cutOffDate}
                                    style={{ fontSize: '11px', backgroundColor: (viewOnly || formData.allowedBackDated === 'No') ? '#e9ecef' : '' }}
                                    disabled={viewOnly || formData.allowedBackDated === 'No'}
                                    autoComplete="off"
                                    placeholder="dd-mm-yy or dd-mmm-yyyy"
                                    onChange={e => setCutOffDateRaw(e.target.value)}
                                    onBlur={() => {
                                        if (formData.allowedBackDated === 'No') return;
                                        if (!viewOnly && cutOffDateRaw) applyCutOffDate(cutOffDateRaw);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === 'Tab') {
                                            if (formData.allowedBackDated === 'No') {
                                                e.preventDefault();
                                                refs.mailingName.current?.focus();
                                                return;
                                            }
                                            if (viewOnly) {
                                                e.preventDefault();
                                                refs.mailingName.current?.focus();
                                                return;
                                            }
                                            if (!cutOffDateRaw) {
                                                e.preventDefault();
                                                toast.error('Cut-Off Date is required', { position: toast.POSITION.TOP_CENTER });
                                                refs.cutOffDate.current?.focus();
                                                return;
                                            }
                                            const ok = applyCutOffDate(cutOffDateRaw);
                                            if (!ok) {
                                                e.preventDefault();
                                                toast.error('Invalid date. Try: 23-12-25 or 23-Dec-2025', { position: toast.POSITION.TOP_CENTER });
                                                refs.cutOffDate.current?.select();
                                            } else {
                                                e.preventDefault();
                                                refs.mailingName.current?.focus();
                                            }
                                        }
                                    }}
                                    onFocus={e => e.target.select()}
                                />
                                {formData.allowedBackDated !== 'No' && formData.cutOffDate && (
                                    <small style={{ color: '#0d6efd', fontSize: '10px', marginTop: '2px', display: 'block' }}>
                                        {formData.cutOffDate}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Mailing Details */}
                    <div className="col-md-6 ps-3">
                        <div className="row mb-2">
                            <div className="col text-start fw-bold text-secondary text-uppercase border-bottom pb-1" style={{ fontSize: '11.5px', letterSpacing: '0.5px' }}>
                                Mailing Details
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-4 fw-bold text-start">Name</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    name="mailingName"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.mailingName}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.mailingName}
                                    style={{ fontSize: '11px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-4 fw-bold text-start">Address</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    name="mailingAddress1"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark mb-1"
                                    value={formData.mailingAddress1}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.mailingAddress1}
                                    style={{ fontSize: '11px' }}
                                    placeholder="Line 1"
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                                <input
                                    type="text"
                                    name="mailingAddress2"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.mailingAddress2}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.mailingAddress2}
                                    style={{ fontSize: '11px' }}
                                    placeholder="Line 2"
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-4 fw-bold text-start">State</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    name="mailingState"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.mailingState}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.mailingState}
                                    style={{ fontSize: '11px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-4 fw-bold text-start">Pincode</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    name="mailingPincode"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.mailingPincode}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.mailingPincode}
                                    style={{ fontSize: '11px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-4 fw-bold text-start">Primary Mobile No.</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    name="mailingMobile"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.mailingMobile}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.mailingMobile}
                                    style={{ fontSize: '11px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-1">
                            <div className="col-4 fw-bold text-start">Email</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="email"
                                    name="mailingEmail"
                                    className="form-control form-control-sm border-secondary fw-bold text-dark"
                                    value={formData.mailingEmail}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.mailingEmail}
                                    style={{ fontSize: '11px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Section - Lists Grid */}
                <div className="table-responsive bg-white rounded border shadow-sm m-0 p-0" style={{ flexGrow: 1, overflowY: 'auto', maxHeight: '35vh' }}>
                    <table className="table table-bordered table-sm text-center m-0 align-middle" style={{ fontSize: '11px' }}>
                        <thead>
                            <tr className="table-secondary align-middle text-uppercase fw-bold text-secondary" style={{ fontSize: '11px', background: '#f1f3f5' }}>
                                <th className="text-start ps-3" style={{ width: '30%', height: '24px' }}>GODOWN</th>
                                <th className="text-start ps-3" style={{ width: '35%' }}>VOUCHER</th>
                                <th className="text-start ps-3" style={{ width: '35%' }}>USER (Username) City</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gridData.map((item, idx) => {
                                return (
                                    <tr key={idx} className="align-middle">
                                        <td className="text-start ps-3 fw-bold text-dark" style={{ height: '22px' }}>{item.godown}</td>
                                        <td className="text-start ps-3 text-muted fw-bold">{item.voucher}</td>
                                        <td className="text-start ps-3 fw-bold text-dark">{item.user}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

            </div>
        </Form>
    );
}

export default React.memo(BranchCreateModal);
